import { IGetAllObraUseCase } from "../../../presentation/useCases/read/get_all_obra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Obra } from "../../models/obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllObraUseCase
 */

export class GetAllObraUseCase extends BasePaginatedUseCase<Obra> implements IGetAllObraUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObra(
    tipoPesquisa: number | null,
    valueField: string | null,
    statusDocumentos: number | null,
    resistenciaCompressao: number | null,
    statusEquipamentos: number | null,
    statusObras: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllObra(
      tipoPesquisa,
      valueField,
      statusDocumentos,
      resistenciaCompressao,
      statusEquipamentos,
      statusObras,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
